import { getSelectedLang } from "../utils/getSelectedLang"
import { defaultLang } from "../_webui/i18n/OjicaI18n"

const CHECK_SELECTED_LANG = getSelectedLang() === defaultLang

export const Constant = {
  CHECK_SELECTED_LANG,
}
